import { render, staticRenderFns } from "./VoucherRelationManagement.vue?vue&type=template&id=0b37be00&scoped=true"
import script from "./VoucherRelationManagement.vue?vue&type=script&lang=js"
export * from "./VoucherRelationManagement.vue?vue&type=script&lang=js"
import style0 from "./VoucherRelationManagement.vue?vue&type=style&index=0&id=0b37be00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37be00",
  null
  
)

export default component.exports